import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { useAppSelector } from '@/redux/hooks';
import { externalServiceSelectors, userSelectors } from '@/redux/selectors';
import {
  listenToHelpCrunch,
  onConsentChange,
  rememberAdClicks,
  setHelpCrunchAccountEmail,
  syncHelpCrunchAttribution,
} from '@/utils/attribution';

const useHelpCrunchAttribution = (): void => {
  const { pathname, search } = useLocation();
  const helpcrunchLoaded = useAppSelector(
    externalServiceSelectors.helpcrunchLoaded,
  );

  const email = useAppSelector(userSelectors.getEmail);

  useEffect(() => {
    rememberAdClicks(search);
  }, [search]);

  useEffect(() => {
    if (helpcrunchLoaded) listenToHelpCrunch();
  }, [helpcrunchLoaded]);

  useEffect(() => {
    setHelpCrunchAccountEmail(email);
    if (helpcrunchLoaded) syncHelpCrunchAttribution();
  }, [helpcrunchLoaded, pathname, search, email]);

  useEffect(() => {
    if (!helpcrunchLoaded) return undefined;

    return onConsentChange(() => syncHelpCrunchAttribution());
  }, [helpcrunchLoaded]);
};

export default useHelpCrunchAttribution;
